import { AxiosPromise } from 'axios';
import { Search } from '../../../constants/search';

import {
  ISearchEngineRequest,
  ISearchEngineGameRequest,
  ISearchParams,
  ILogSearchParams,
  IGameSearchResponse,
  IExchangeSearchResponse,
  IAssetAccessSearchResponse,
  ISearchEngineGamesRequest,
} from './interfaces';
import { IUser as IIdmUser } from '../../idm/interfaces';
import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { VAULT_VIDEO_TYPE } from '../../../constants';

export const searchAssets = (params: ISearchParams, impersonatedUser?: IIdmUser): AxiosPromise<IApiResponse<IGameSearchResponse>> => {
  const request: ISearchEngineRequest = {
    params,
    impersonatedUserId: impersonatedUser ? impersonatedUser.id : null,
    unRestrictedResponse: true,
  };
  return vaultApi.getInstance().post('/search/query', request);
};

export const getAssetFromES = async (assetId: string) => {
  const request: ISearchEngineRequest = {
    params: {
      queryString: '',
      size: 50,
      page: 1,
      filters: [['_id', [assetId]]],
    },
    impersonatedUserId: null,
    unRestrictedResponse: true,
  };
  return vaultApi.getInstance().post('/search/query', request);
};

export const defaultExchangeSearchParams: ISearchParams = {
  queryString: '',
  size: Search.DEFAULT_EXCHANGE_RESULTS_LIMIT_SIZE,
  page: Search.DEFAULT_PAGE,
  sortOrder: 'desc' as 'desc',
  sortField: 'exchangeGameKey',
};

export const defaultExchangeFilters = [
  ['videoType', [VAULT_VIDEO_TYPE.Exchange]],
];

export const searchExchangeAssets = (
  params: ISearchParams,
  impersonatedUser?: IIdmUser,
): AxiosPromise<IApiResponse<IExchangeSearchResponse>> => {
  const request: ISearchEngineRequest = {
    params,
    impersonatedUserId: impersonatedUser ? impersonatedUser.id : null,
    unRestrictedResponse: true,
  };

  return vaultApi.getInstance().post('/search/query', request);
};

export const searchGames = (params: ISearchParams, teamId: string): AxiosPromise<IApiResponse<IExchangeSearchResponse>> => {
  const request: ISearchEngineGameRequest = {
    params,
    game: {
      teamId,
    },
    unRestrictedResponse: true,
  };
  return vaultApi.getInstance().post('/search/games/query', request);
};

export const searchGamesByTeamIds = (params: ISearchParams, teamIds: string[]): AxiosPromise<IApiResponse<IExchangeSearchResponse>> => {
  const request: ISearchEngineGamesRequest = {
    params,
    games: teamIds.map((teamId) => ({ teamId })),
    unRestrictedResponse: true,
  };
  return vaultApi.getInstance().post('/search/games/queryByTeams', request);
};

export const searchAssetAccessLogs = (
  params: ILogSearchParams,
  impersonatedUser?: IIdmUser,
): AxiosPromise<IApiResponse<IAssetAccessSearchResponse>> => {
  const request: ISearchEngineRequest = {
    params,
    impersonatedUserId: impersonatedUser ? impersonatedUser.id : null,
    unRestrictedResponse: true,
  };

  return vaultApi.getInstance().post('/search/assetAccessLogs/query', request);
};
